export default {
  type: 'my_review_group',
  name: 'Group',
  save: {
    fields: [
      {
        field: 'groupId',
        type: 'Int',
        required: true
      },
      'groupName',
      'groupTitle',
      'groupDescription',
      'groupTypeCode',
      'roleRecords',
      'peopleRecords'
    ],
    key: ['groupId']
  },
  load: {
    key: 'groupByGroupId'
  },
  form: {
    editHeader: 'Review Group ${groupId} - ${groupName}',
    redirects: false,
    print: false,
    schema: [
      {
        name: 'groupName',
        labelWidth: 2,
        readonly: true
      },
      {
        name: 'groupTitle',
        labelWidth: 2
      },
      {
        name: 'groupDescription',
        labelWidth: 2,
        type: 'textarea'
      },
      {
        name: 'groupTypeCode',
        label: 'Group Type',
        labelWidth: 2,
        type: 'select',
        required: true,
        options: {
          lookup: 'allGroupTypes',
          value: 'groupTypeCode',
          text: 'groupTypeDesc'
        }
      },
      {
        name: 'roleRecords',
        label: 'Roles',
        labelWidth: 12,
        type: 'results',
        fields: [
          {
            key: 'roleName',
            sortable: true,
            required: true
          },
          {
            key: 'roleTitle',
            sortable: true
          },
          'members',
          {
            key: 'selected',
            label: 'Remove'
          }
        ]
      },
      {
        name: 'peopleRecords',
        label: 'Members',
        labelWidth: 12,
        type: 'results',
        fields: [
          {
            key: 'personId',
            sortable: true,
            required: true
          },
          {
            key: 'name',
            sortable: true,
            required: true
          },
          {
            key: 'affiliation',
            sortable: true
          },
          {
            key: 'selected',
            label: 'Remove'
          }
        ]
      },
      {
        name: 'addMembers',
        type: 'graphql_form_search_multi',
        fields: [
          {
            key: 'personId',
            sortable: true,
            required: true
          },
          {
            key: 'fullName',
            label: 'Name',
            sortable: true
          },
          {
            key: 'affiliation',
            sortable: true
          },
          {
            key: 'email',
            sortable: true
          },
          {
            key: 'remove'
          }
        ],
        formType: 'people',
        multiHeader: 'Added ${fullName} to group',
        addLabel: 'Add Member',
        searchFilters: {
          statusCode: {
            in: {
              type: 'StringArray',
              array: true,
              required: true,
              default: '["A", "F"]'
            }
          }
        },
        message:
          'If you are trying to add a new or transition an ARM staff member, please use the New ARM Staff tab on the main review page.  Otherwise if you cannot find the person you are trying to add, please add them to the "Other Changes" below with contact information.'
      },
      {
        name: 'other',
        label: 'Other Changes',
        labelWidth: 2,
        type: 'textarea'
      }
    ],
    submitLabel: 'Submit Change Request'
  }
}
